import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../../data/site';
export function UtilityBar() {
  return <div className="bg-afb-black text-[13px] text-white/70" data-id="element-174" data-mp="1wqbbysxry8iw">
      <div className="mx-auto flex h-9 max-w-page items-center justify-between gap-4 px-5 lg:px-8" data-id="element-175" data-mp="2airc9lzajsg4">
        <p className="hidden md:block" data-id="element-176" data-mp="25iv4dbnh3gva">Perth-based · Australia-wide</p>
        <p className="flex items-center gap-2 font-medium text-white" data-id="element-177" data-mp="1htkckjo3owta">
          <span className="h-1.5 w-1.5 rounded-full bg-afb-turquoise" aria-hidden="true" data-id="element-178" data-mp="1htu2y8d255zi" />
          {contact.response}
        </p>
        <div className="flex items-center gap-5" data-id="element-179" data-mp="1rrq9snyypert">
          <a href={contact.phoneHref} className="flex items-center gap-1.5 transition-colors duration-150 hover:text-white" data-id="element-180" data-mp="1rtb7unkhjfuf">
            <PhoneIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-181" data-mp="1muq7mo58gw5z" />
            <span data-id="element-182" data-mp="335lpbxts3pjk">
              <span className="hidden sm:inline" data-id="element-183" data-mp="3352bas791lat">Call </span>
              {contact.phoneDisplay}
            </span>
          </a>
          <a href={contact.emailHref} className="hidden items-center gap-1.5 transition-colors duration-150 hover:text-white md:flex" data-id="element-184" data-mp="1yncih8391idd">
            <MailIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-185" data-mp="23kku0ptw6o5n" />
            {contact.email}
          </a>
        </div>
      </div>
    </div>;
}